import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

function IconGeoObjCrosslineZS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M15 14.382V7.61803C15 7.23926 14.786 6.893 14.4472 6.72361L2.44721 0.723607C1.78231 0.391156 1 0.874652 1 1.61803L1 8.38197C1 8.76074 1.214 9.107 1.55279 9.27639L13.5528 15.2764C14.2177 15.6088 15 15.1253 15 14.382Z"
        fill="currentcolor"
      />
    </svg>
  )
}
export const IconGeoObjCrosslineZ = createIcon({
  l: IconGeoObjCrosslineZS,
  m: IconGeoObjCrosslineZS,
  s: IconGeoObjCrosslineZS,
  xs: IconGeoObjCrosslineZS,
  name: 'IconGeoObjCrosslineZ',
})
